import Image from 'next/image';
import { Trans, useTranslation } from 'next-i18next';

import Button from '@/common/button';

interface GamesProps {
  t?: (key: string, options?: { count: number }) => string;
  daysTrial: number;
  scrollToForm?: React.RefObject<HTMLElement>;
  isActivedButton: boolean;
  bgImage?: string;
}

export function Games({ t: tProp, daysTrial, scrollToForm, isActivedButton = true, bgImage = '/assets/images/trial/new/bg-jogos.webp' }: GamesProps) {
  const { t: tOwn } = useTranslation('components/trial/games');
  const t = tProp ?? tOwn;

  return (
    <section className='mx-auto mb-10 flex w-full flex-col items-center justify-center tablet:h-[900px]'>
      <div style={{ backgroundImage: `url(${bgImage})` }} className='flex w-full flex-col items-center justify-center gap-10 bg-cover bg-no-repeat max-ipad:bg-cover max-ipad:bg-center tablet:h-[800px]'>
        <h3 className='mt-5 text-center text-5xl font-bold leading-10 text-white tablet:text-7xl'>
          <Trans i18nKey='games_section.text01' components={{ span: <span className='text-[#93FF18]' /> }}>
            {t('games_section.text01')}
          </Trans>
        </h3>
        <div className='mx-auto grid max-w-[1320px] grid-cols-3 place-items-center gap-5 px-5 pt-10 tablet:grid-cols-6 ipad:grid-cols-8 laptop:gap-10'>
          <Image src='/assets/images/trial/new/games/FORTNITE.webp' alt='Logo FORTNITE' width={124} height={45} className='h-auto' />
          <Image src='/assets/images/trial/new/games/CODWARZONE.webp' alt='Logo CODWARZONE' width={104} height={38} className='h-auto' />
          <Image src='/assets/images/trial/new/games/OVERWATCH.webp' alt='Logo OVERWATCH' width={109} height={59} className='h-auto' />
          <Image src='/assets/images/trial/new/games/LOL.webp' alt='Logo LOL' width={104} height={44} className='h-auto' />
          <Image src='/assets/images/trial/new/games/CS2.webp' alt='LOGO CS2' width={108} height={46} className='h-auto' />
          <Image src='/assets/images/trial/new/games/PUBG.webp' alt='LOGO PUBG' width={149} height={46} className='h-auto' />
          <Image src='/assets/images/trial/new/games/VALORANT.webp' alt='LOGO VALORANT' width={167} height={25} className='h-auto' />
          <Image src='/assets/images/trial/new/games/DOTA2.webp' alt='LOGO DOTA 2' width={54} height={68} className='h-auto' />
          <Image src='/assets/images/trial/new/games/R6.webp' alt='LOGO R6' width={174} height={31} className='h-auto' />
          <Image src='/assets/images/trial/new/games/ROCKETLEAGUE.webp' alt='LOGO ROCKET LEAGUE' width={171} height={42} className='h-auto' />
          <Image src='/assets/images/trial/new/games/GOOGLE_CHROME.webp' alt='LOGO GOOGLE CHROME 1' width={61} height={61} className='h-auto' />
          <Image src='/assets/images/trial/new/games/DISCORD.webp' alt='LOGO DISCORD' width={120} height={33} className='h-auto' />
          <Image src='/assets/images/trial/new/games/APEX.webp' alt='LOGO APEX' width={60} height={38} className='h-auto' />
          <Image src='/assets/images/trial/new/games/MINECRAFT.webp' alt='LOGO MINECRAFT' width={157} height={26} className='h-auto' />
          <Image src='/assets/images/trial/new/games/ETARKOV.webp' alt='LOGO ETARKOV' width={120} height={42} className='h-auto' />
          <Image src='/assets/images/trial/new/games/TIBIA.webp' alt='LOGO TIBIA' width={115} height={36} className='h-auto' />
          <Image src='/assets/images/trial/new/games/NIGHT-CROWS.webp' alt='LOGO NIGHT CROWS' width={124} height={64} className='h-auto' />
          <Image src='/assets/images/trial/new/games/ROBLOX.webp' alt='LOGO ROBLOX' width={124} height={64} className='h-auto' />
          <Image src='/assets/images/trial/new/games/FFXIV.webp' alt='LOGO FFXIV' width={117} height={88} className='h-auto' />
          <Image src='/assets/images/trial/new/games/POE.webp' alt='LOGO POE' width={101} height={79} className='h-auto' />
          <Image src='/assets/images/trial/new/games/WOW.webp' alt='LOGO WOW' width={112} height={42} className='h-auto' />
          <div className='col-span-3 flex w-full items-center justify-center gap-6 rounded-ee-[30px] rounded-ss-[30px] bg-[#93FF18] px-4 text-black tablet:w-auto'>
            <p className='text-lg font-bold text-black mobile:text-3xl tablet:text-7xl ipad:text-8-5xl'>+3000</p>
            <p className='text-base font-bold text-black mobile:text-xl tablet:leading-6 ipad:text-3xl ipad:leading-6'>
              <Trans i18nKey='games_section.text02' components={{ br: <br /> }}>
                {t('games_section.text02')}
              </Trans>
            </p>
          </div>

          {isActivedButton && (
            <Button
              fullWidth
              className='col-span-full flex items-center justify-center gap-5 bg-[#93FF18] !p-4 text-lg font-bold text-black hover:opacity-80 sm:text-4xl'
              style={{ boxShadow: '0px 10px 20px 0px #93FF1840' }}
              onClick={() => {
                const targetElement = scrollToForm?.current;
                if (targetElement) {
                  const elementOffsetTop = targetElement.getBoundingClientRect().top;
                  const scrollPosition = elementOffsetTop + window.scrollY - 100;
                  window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
                }
              }}
            >
              {t('games_section.button', { count: daysTrial })}
            </Button>
          )}
        </div>
      </div>
    </section>
  );
}
